module.exports = function (amount) {
    if (amount <= 1100000) {
        return 0;
    } else if (amount <= 1512500) {
        return (amount - 1100000) * 0.03;
    } else if (amount <= 2117500) {
        return 12375 + ((amount - 1512500) * 0.06);
    } else if (amount <= 2722500) {
        return 48675 + ((amount - 2117500) * 0.08);
    } else if (amount <= 12100000) {
        return 97075 + ((amount - 2722500) * 0.11);
    } else {
        return 1128600 + ((amount - 12100000) * 0.13);
    }
};
